export const defaultData = [
    {
      text: "Use the ",
      code: ".list-group ",
    },
    {
      text: "define the list of items. and used ",
      code: ".list-group-item ",
    },
    {
      text: "to indicate the current content.",
    },
  ];
  
  export const defaultListData = ["Web Design & Development", "E-Commerce", "SEO"];
  
  export const activeData = [
    {
      text: "Use",
      code: ".active ",
    },
    {
      text: "to a",
      code: ".list-group-item",
    },
    {
      text: "to indicate the current active.",
    },
  ];
  
  export const activeListData = ["Wow Animations", "Apex Charts", "Starter Kits"];
  
  export const flushData = [
    {
      text: "Use ",
      code: " .list-group-flush",
    },
    {
      text: " to remove some borders and rounded corners to render list group items.",
    },
  ];
  
  export const flushListData = ["PRODUCT DETAILS", "CART", "CHECKOUT"];
  
  export const contextualData = [
    {
      text: "Use contextual classes to style list items with a stateful background and color.",
      code: ".list-light-*",
    },
    {
      text: " and ",
      code: "txt-*",
    },
  ];
  
  export const contextualDataList = ["secondary", "success", "danger", "warning", "info", "white", "dark"];
  
  export const horizontalData = [
    {
      text: "Use ",
      code: ".list-group-horizontal",
    },
    {
      text: "to change the layout of list group items from vertical to horizontal across all breakpoints.",
      code: ".list-group-horizontal-[sm/md/lg/xl/xxl].",
    },
  ];
  
  export const horizontalListData = [
    {
      color: "secondary",
      item: ["Basic table", "Sizing table ", "Border table", "Basic inputs ", "Form validations"],
    },
  
    {
      color: "warning",
      item: ["Flat style ", "Edge style ", "Button group", "Rating", "Crypto"],
    },
    {
      color: "success",
      item: ["Blog ", "Blog details ", "Blog single ", "Order history "],
    },
    {
      color: "info",
      item: ["Gallery grid  ", "Gallery desc", "Masonry Desc"],
    },
  ];
  
  export const horizontalDataList = ["Product details", "Pricing", "Payment details", "Checkout ", "Mega options "];
  
  export const customData = [
    {
      text: "Use the ",
      code: ".list-group-item",
    },
    {
      text: " through make custom design of all lists.",
    },
  ];
  
  export const customList = [
    {
      src: "user/3.png",
      title: "Gabrielle Fahey",
      mail: "GabrielleFahey@dayrep.com",
      days: "10 days ago",
      text: "Your aim with this blog is to advertise yourself and your services in blog design. That means it's vital to create content about just that: blog design. Anything else on your page may act as a distraction to your potential customers, and you don't want that!",
      smallText: "100 Followers",
    },
  
    {
      src: "user/2.jpg",
      title: "Lucinda Moseley",
      mail: "LucindaMoseley@teleworm.us",
      days: "3 days ago",
      text: "People who are looking to hire a web designer may not know what to look out for. This will give you a chance to prove your trustworthiness by providing potential customers with advice and will let you sell your services by highlighting their best qualities.",
      smallText: "23M Followers ",
    },
  ];
  
  export const listCheckboxData = [
    {
      text: "Use the ",
      code: ".form-check-input ",
    },
    {
      text: "to check your checkbox.",
    },
  ];
  
  export const checkboxDataList = [
    {
      id: 1,
      color: "secondary",
      text: "Auto Update",
    },
    {
      id: 2,
      color: "success",
      text: " Don't check auth key",
    },
    {
      id: 3,
      color: "warning",
      text: "Success all",
    },
  ];
  
  export const listRadioData = [
    {
      text: "Use the ",
      code: ".form-check-input ",
    },
    {
      text: "to check your radio buttons.",
    },
  ];
  
  export const listRadioDataList= [
    {
      id: 1,
      color: "primary",
      text: "Read a book",
    },
    {
      id: 2,
      color: "success",
      text: "Learn to code ",
    },
    {
      id: 3,
      color: "info",
      text: "Drink more water",
    },
  ];
  
  export const listNumberData = [
    {
      text: "Use the ",
      code: ".list-group-numbered",
    },
    {
      text: "to ordered wise print numbers.",
    },
  ];
  
  export const listNumberDataList = [
    {
      color: "danger",
      text: "Solve your problem with us",
    },
    {
      color: "success",
      text: "Certified Professionals",
    },
    {
      color: "warning",
      text: "Growth-Driven ",
    },
  ];
  
  export const javaScriptData = [
    {
      text: " Use the tab JavaScript plugin—include it individually or through the compiled",
      code: " bootstrap.js ",
    },
    {
      text: "file to extend our list group to create table panes of local content.",
    },
  ];
  
  export const numberBadgeData = [
    {
      text: "  Use the",
      code: " .list-group-numbered",
    },
    {
      text: " modifier class to  numbered list group items.Numbers are generated via CSS for better placement inside list group items.",
    },
  ];
  
  export const numberBadgeDataList = [
    {
      title: "Lola Stanford",
      color: "danger",
      text: "Issue",
    },
    {
      title: "Caitlin Coungeau",
      color: "primary",
      text: "Social",
    },
    {
      title: "Graciela W. McClaran",
      color: "danger",
      text: "Issue",
    },
  ];
  
  //Disabled List
  export const disableListData = [
    {
      text: "  Use ",
      code: " .disabled ",
    },
    {
      text: "to a ",
      code: ".list-group-item ",
    },
    {
      text: " to make it appear disabled.",
    },
  ];
  
  export const disableList = [
    {
      className: "list-hover-primary",
      text: "Gloria D. Acheson",
      src: "user/3.png",
    },
    {
      className: "disabled",
      text: "Sharon C. Obrien",
      src: "user/2.jpg",
    },
    {
      className: "disabled",
      text: "Bryan A. Owens",
      src: "user/5.jpg",
    },
  ];
  
  export const scrollableData = [
    {
      text: "Use the property ",
      code: "overflow:auto ",
    },
    {
      text: "through scrollable lists.",
    },
  ];
  
  export const scrollableDataList = [
    {
      src: "user/10.jpg",
      title: "Gabrielle Fahey",
      mail: "GabrielleFahey@dayrep.com",
      days: "10 days ago",
    },
    {
      src: "user/2.jpg",
      title: "Lucinda Moseley",
      mail: "LucindaMoseley@teleworm.us",
      days: "3 days ago",
    },
    {
      src: "user/12.png",
      title: "Francis K. Henriques",
      mail: "FrancisKHenriques@teleworm.us",
      days: "2 days ago",
    },
    {
      src: "user/14.png",
      title: "Jose A. Seay",
      mail: "JoseASeay@rhyta.com",
      days: "15 days ago",
    },
    {
      src: "user/3.jpg",
      title: "Phil F. Cunningham",
      mail: "PhilFCunningham@dayrep.com",
      days: "6 days ago",
    },
    {
      src: "user/7.jpg",
      title: "Richard E. Johnson",
      mail: "RichardEJohnson@teleworm.us",
      days: "20 days ago",
    },
    {
      src: "user/2.png",
      title: "Lawrence L. Nash",
      mail: "LawrenceLNash@jourrapide.com",
      days: "8 days ago",
    },
  ];